import { Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, combineLatest, of, Subscription } from 'rxjs';
import { map, mergeMap } from "rxjs/operators";
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from "@angular/forms";
import {
  DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwComponent, DwComponentType, DwMetaDataService,
  DwSectionBaseComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfig,
  DwMetaDataFormApi, DwMetaDataRoutingService, DwMenuActionType, DwModalConfig,
  DwUIMetaDataConfigToken, DwMetaDataServiceToken, DwMetaDataFormStateService, DwFormActionInterceptor,
  DwEventService, DwGridActionResult,
  DwMessage,
  DwMessageSeverity
}
  from '@devwareapps/devware-cap';
import { AviatorUser } from '../../../shared/models/aviator-user.model';
import { Inject, Injectable } from "@angular/core";
import {
  AppMetaDataItemNames, SubscriptionTierBenefitEntity, SubscriptionTierEntity,
  RoSchoolSubscriptionEntity, SubscriptionEntity, SubscriptionStatusAllItems,
  ProcessorConfigEntity, PaymentMethodEntity
}
  from '../../../../meta-data/app-meta-data.service';
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { CreateCustomerResult } from "src/app/features/payments/models/create-customer-result.model";
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import { EnvironmentConfigItem } from 'src/environments/models/environment-config.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { AdminManagerService } from 'src/app/features/admin/services/admin-manager.service';
import { DiscountView, DiscountCodeComponent } from '../discount-code/discount-code.component';
import { PricingDiscountResult } from '../../models/pricing-discount-result.model';
import { PaymentsPricingRepositoryService } from '../../services/payments-pricing-repository.service';
import { SubscriptionPriceRequest } from '../../models/subscription-price-request.model';
import { SubscriptionPriceResult } from '../../models/subscription-price-result.model';
import { PaymentParty } from '../../models/payment-party.enum';
import { SubscriptionCurrentDetails } from '../../models/subscriptions/subscription-current-details.model';
import { SubscriptionTierDetail } from '../../models/subscriptions/subscription-tier-detail.model';
import { SubscriptionManagerService } from '../../services/subscription-manager.service';

@DwComponent({
  key: 'subscription-settings',
  name: 'Subscription Settings',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.FlightSchool,
})
@Component({
  selector: 'app-subscription-settings',
  templateUrl: './subscription-settings.component.html',
  styleUrls: ['./subscription-settings.component.scss']
})
export class SubscriptionSettingsComponent extends DwSectionBaseComponent implements OnInit, OnDestroy {
  formApi: DwMetaDataFormApi;
  aviatorUser: AviatorUser;
  isFSAdmin: boolean;
  discountCode: string = undefined;
  @Input() discountResult: PricingDiscountResult;
  pricing: SubscriptionPriceResult;

  currentSubscription: SubscriptionCurrentDetails;
  tiers: SubscriptionTierEntity[];
  message: DwMessage;

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwFormStateService: DwMetaDataFormStateService,
    private dwSecurityUserService: DwSecurityUserService,
    private dwEventService: DwEventService,
    private dwMetaDataRoutingService: DwMetaDataRoutingService,
    private paymentsRepositoryService: PaymentsRepositoryService,
    private paymentPricingRespository: PaymentsPricingRepositoryService,
    private dateTimeUtilService: DateTimeUtilService,
    private adminManagerService: AdminManagerService,
    private subscriptionManagerService: SubscriptionManagerService,
    private http: HttpClient,
    @Inject(DwConfigServiceToken) private configService: DwConfigService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    // this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    this.formApi = this.dwFormStateService.state.formApi;
  }


  setupComponentComplete() {
    //this.test = this.isTest();
    this.aviatorUser = this.adminManagerService.getAviatorUser();

    this.isFSAdmin = this.dwSecurityUserService.hasPermission(AppPermissions.flightSchoolAdmin);

    this.loadData();
  }

  loadData() {
    const obs: Observable<any>[] = [];

    obs.push(this.paymentsRepositoryService.getCurrentSubscriptionDetails());
    obs.push(this.paymentsRepositoryService.getSubriptionTiers());

    combineLatest(obs)

      .subscribe(([currentSub, tiers]) => {
        this.currentSubscription = currentSub;
        this.pricing = this.currentSubscription.PriceResult;
        this.tiers = tiers;

        this.discountResult = this.pricing.TierPricing.find(t => t.SubscriptionTier.SubscriptionTierId == this.currentSubscription?.ActiveSubscription.SubscriptionTierId)?.DiscountResult;

        this.setupSubscriptTierDetails();
      });
  }

  subscriptionTierDetails: SubscriptionTierDetail[] = [];

  setupSubscriptTierDetails() {
    this.subscriptionTierDetails = [];
    for (const tier of this.tiers) {

      const tierPrcing = this.pricing.TierPricing.find(t => t.SubscriptionTier.SubscriptionTierId == tier.SubscriptionTierId);

      const tierDetail: SubscriptionTierDetail = {
        subscriptionTier: tier,
        isActive: (tier.SubscriptionTierId == this.currentSubscription?.ActiveSubscription?.SubscriptionTierId),
        isFuture: (tier.SubscriptionTierId == this.currentSubscription?.FutureSubscription?.SubscriptionTierId),
        fullPrice: tierPrcing.PlatformRetailPrice,
        discountPrice: tierPrcing.FinalPrice,
      }

      if (tierDetail.isActive) {
        tierDetail.cardClass = 'active';
      }
      if (tierDetail.isFuture) {
        tierDetail.cardClass = 'future';
      }

      this.subscriptionTierDetails.push(tierDetail);
    }
  }

  switchTo(tier: SubscriptionTierDetail) {
    this.subscriptionManagerService.startSubscriptionChange(this.currentSubscription?.ActiveSubscription?.SubscriptionId, tier.subscriptionTier.SubscriptionTierId)
      .subscribe((result) => {
        if (!result.cancelled) {
          if (result.data.Message) {
            this.message = {
              messageBody: result.data.Message,
              allowClose: true,
              severity: DwMessageSeverity.success
            }
          }

          // Need to refresh the subscription details
          this.loadData();
        }
      });
    }

    getPriceRequest(): SubscriptionPriceRequest {
      const pricingRequest: SubscriptionPriceRequest = {
        DiscountCode: this.discountCode
      };
      return pricingRequest;
    }

    updateDiscounts() {
      this.paymentPricingRespository.getSubscriptionPricing(this.getPriceRequest())
        .subscribe(pricingResult => {
          this.pricing = pricingResult;
          this.discountResult = pricingResult.TierPricing
            .find(t => t.SubscriptionTier.SubscriptionTierId == this.currentSubscription?.ActiveSubscription?.SubscriptionTierId)?.DiscountResult;
          this.saveCode();
        });
    }

    saveCode() {
      const currentCode = this.discountResult?.DiscountCode;
      const targetCode = this.discountCode ?? "";
      if (currentCode != targetCode) {

        this.paymentsRepositoryService.applySubscriptionDiscountCode(this.currentSubscription?.ActiveSubscription?.SubscriptionTierId, targetCode);
      }
    }

    onDiscountCodeChange(e: string) {
    }

    onDiscountCodeApplied(e: string) {
      this.discountCode = e;
      this.updateDiscounts();
    }

    onDiscountCodeCleared() {
      this.discountCode = '';
      this.updateDiscounts();
      this.saveCode();
    }
  }
